<div class="row">
    <div class="col-md-12">
        <div class="bots-filters px-3 py-4">
            <div class="row">
                <div class="col-md-2">
                    <label class="list-title">{{ 'bots.typeSelector' | translate }}</label>
                    <select name="botType" class="form-control" [(ngModel)]="searchedType" (change)="filterType();$event.stopPropagation()">
                        <option disabled selected>{{ 'general.select' | translate }}</option>
                        <option value="data">{{ 'bots.dataBot' | translate }}</option>
                        <option value="document">{{ 'bots.documentBot' | translate }}</option>
                        <option value="message">{{ 'bots.messageBot' | translate }}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label *ngIf="searchedType" class="list-title">{{ 'bots.categorySelector' | translate }}</label>
                    <select *ngIf="searchedType === 'data'" name="category" class="form-control" [(ngModel)]="searchedCat" (change)="filterCat();$event.stopPropagation()">
                        <option disabled selected>{{ 'general.select' | translate }}</option>
                        <option value="create">{{ 'bots.categoryCreate' | translate }}</option>
                        <option value="exist">{{ 'bots.categoryExist' | translate }}</option>
                        <option value="list">{{ 'bots.categoryList' | translate }}</option>
                        <option value="read">{{ 'bots.categoryRead' | translate }}</option>
                        <option value="log">{{ 'bots.categoryLog' | translate }}</option>
                        <option value="update">{{ 'bots.categoryUpdate' | translate }}</option>
                        <option value="listener">{{ 'bots.categoryListener' | translate }}</option>
                        <option value="other">{{ 'bots.categoryOther' | translate }}</option>
                    </select>
                    <select *ngIf="searchedType === 'document'" name="category" class="form-control" [(ngModel)]="searchedCat" (change)="filterCat();$event.stopPropagation()">
                        <option disabled selected>{{ 'general.select' | translate }}</option>
                        <option value="document_generate_and_display">{{ 'bots.document_generate_and_display' | translate }}</option>
                        <option value="document_generate_and_upload">{{ 'bots.document_generate_and_upload' | translate }}</option>
                        <option value="document_generate_upload_display">{{ 'bots.document_generate_upload_display' | translate }}</option>
                        <option value="document_upload">{{ 'bots.document_upload' | translate }}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <label *ngIf="(searchedType && searchedCat) || selectedBotId" class="list-title">{{ 'Bots' | translate }}</label>
                    <select *ngIf="(searchedType && searchedCat) || selectedBotId"  class="form-control" [(ngModel)]="selectedBotId" (change)="selectBot($event);$event.stopPropagation()">
                        <option disabled selected>{{ 'general.select' | translate }}</option>
                        <option *ngFor="let b of availableBots" value="{{ b.id }}">{{ b.name }}</option>
                    </select>
                </div>
                <div class="col-md-2" *ngIf="(searchedType && searchedCat) || selectedBotId">
                    <label class="list-title">&nbsp;</label>
                    <button class="btn btn-primary btn-rounded mt-2 d-block" (click)="addNewBot()">{{ 'bot.selector.add' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="row" *ngIf="selectedBot">
    <div class="col-md-12">
        <div class="bots-details pt-3">
            <div class="role-main-tabs d-flex">
                <div class="role-tab {{activeTab === 'general' ? 'active-tab': ''}}" (click)="notifyTabChange('general')">
                    {{ 'roles.generalTab' | translate }}
                </div>
                <div *ngIf="selectedBot && selectedBot.botType !== 'document'"
                    class="role-tab {{activeTab === 'bot-service' ? 'active-tab': ''}}"
                    (click)="notifyTabChange('bot-service')"
                    [ngClass]="{'disabled': !mappingReady}">
                    <i *ngIf="!mappingReady" class="far fa-sync-alt fa-spin"></i> {{ 'roles.botservice' | translate }}
                </div>
            </div>

            <div class="role-main-tabs-content">
                <div class="role-tab-content tab-general {{activeTab === 'general' ? 'active-tab': ''}}">
                    <div class="role-tab-inner">
                        <role-bot-manage [fromRole]="true" (changedData)="updatedRole()" (addedFromRoleEvent)="addedNewBot($event);" [serviceId]="serviceId" [bot]="selectedBot" *ngIf="activeTab === 'general'"></role-bot-manage>
                    </div>
                </div>
                <div *ngIf="selectedBot && selectedBot.id && selectedBot.botType !== 'document'" class="role-tab-content tab-bot-service {{activeTab === 'bot-service' ? 'active-tab': ''}}">
                    <service-role *ngIf="role && role.type === 'BotRole'"
                        [bot]="selectedBot"
                        [serviceId]="serviceId"
                        (saveData)="updateBot(selectedBot)"
                        (mappingReady)="onMappingReady($event)">
                    </service-role>
                </div>
            </div>

        </div>
    </div>
</div>
